export default "__VITE_ASSET__D5i9Y9ID__"